import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom'; // 1. Importar useParams
import i18n from './i18n'; // 2. Importación directa de la instancia
import '../styles-v2/About.css';

// Importa tus imágenes
import image1 from '../Image/img 1.jpg';
import image3 from '../Image/img 3.jpg';
import image5 from '../Image/img 5.jpg';
import image6 from '../Image/img 6.jpg';
import image7 from '../Image/img 7.jpg';
import image8 from '../Image/img 8.jpg';
import image9 from '../Image/img 9.jpg';
import image10 from '../Image/img 10.jpg';

const About = () => {
    const { t } = useTranslation();
    const { lang } = useParams(); // Obtenemos el idioma de la URL

    // 3. Sincronización obligatoria con la URL para SEO y navegación directa
    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang]);

    const images = [
        { src: image1, alt: 'Safety measurement 1', description: t('services_slider.desc_1') },
        { src: image3, alt: 'Regulations analysis', description: t('services_slider.desc_3') },
        { src: image5, alt: 'Measurement 5', description: t('services_slider.desc_5') },
        { src: image6, alt: 'Measurement 6', description: t('services_slider.desc_6') },
        { src: image7, alt: 'Measurement 7', description: t('services_slider.desc_7') },
        { src: image8, alt: 'Measurement 8', description: t('services_slider.desc_8') },
        { src: image9, alt: 'Measurement 9', description: t('services_slider.desc_9') },
        { src: image10, alt: 'Measurement 10', description: t('services_slider.desc_10') },
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    useEffect(() => {
        if (images.length === 0) return;
        const interval = setInterval(nextImage, 5000);
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentImageIndex]);

    return (
        <section id="nosotros"> {/* Aseguramos el ID para el scroll del Navbar */}
            <div className="about-container-split">
                {/* --- LADO IZQUIERDO: CARRUSEL --- */}
                <div className="about-side image-side">
                    <div className="image-carousel-fixed">
                        <div className="carousel-wrapper">
                            <img
                                src={images[currentImageIndex].src}
                                alt={images[currentImageIndex].alt}
                                className="carousel-img-fixed"
                            />

                            <div className="carousel-description">
                                <p>{images[currentImageIndex].description}</p>
                            </div>

                            <button
                                className="nav-btn prev"
                                onClick={prevImage}
                                aria-label={t('services_slider.btn_prev')}
                            >
                                ❮
                            </button>
                            <button
                                className="nav-btn next"
                                onClick={nextImage}
                                aria-label={t('services_slider.btn_next')}
                            >
                                ❯
                            </button>
                        </div>
                    </div>
                </div>

                {/* --- LADO DERECHO: TEXTO --- */}
                <div className="about-side text-side">
                    <h2>{t('services_slider.title')}</h2>
                    <div className="about-text-content">
                        <p>
                            {t('services_slider.description')}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;